import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_2 = { class: "kn-list-item-text" }
const _hoisted_3 = { class: "kn-list-item-text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")

  return (!_ctx.load)
    ? (_openBlock(), _createBlock(_component_Listbox, {
        key: 0,
        class: "kn-list--column",
        options: _ctx.attributes,
        filter: true,
        filterPlaceholder: _ctx.$t('common.search'),
        optionLabel: "userId",
        filterMatchMode: "contains",
        filterFields: _ctx.profileAttributesManagementDescriptor.globalFilterFields,
        emptyFilterMessage: _ctx.$t('managers.widgetGallery.noResults'),
        onChange: _ctx.onAttributeSelect,
        "data-test": "attributes-list"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        option: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(slotProps.option.attributeName), 1),
              _createVNode("span", _hoisted_3, _toDisplayString(slotProps.option.attributeDescription), 1)
            ]),
            _createVNode(_component_Button, {
              icon: "far fa-trash-alt",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: ($event: any) => (_ctx.deleteAttribute(slotProps.option.attributeId)),
              "data-test": 'delete-button'
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage", "onChange"]))
    : _createCommentVNode("", true)
}